<template>
  <div id="app" style="margin: 5px; overflow-y: hidden;display:flex; padding-top: var(--safe-area-inset-top); padding-bottom: var(--safe-area-inset-bottom); padding-left: var(--safe-area-inset-left); padding-right: var(--safe-area-inset-right);">
    <button v-if="!isPanelVisible" @click="togglePanel" class="toggle-button" style="position: absolute; top: 80px;" >
      <div style="margin: 5px;" >
      <div v-if="!labpagestatus"><v-icon style="margin: 5px;" size="30" color="primary" @click="openPage('contactInfo')">mdi-account-details</v-icon></div>
            <div v-if="!labpagestatus">
              <v-icon
                size="30px"
               color="amber"
                @click="openPage('uploadfileOD')"               
              > mdi-folder-arrow-up
              </v-icon>
            </div>
      <div><v-badge v-if="unreadMessages.length" :color="'#FB4141'" :content="unreadMessages.length">
              <v-icon size="30" color="green" @click="openPage('internalConversations')">mdi-chat</v-icon>
          </v-badge>
          <v-icon v-else size="30" color="green" @click="openPage('internalConversations')">mdi-chat</v-icon>
      </div>
      <div v-if="isODEnabled"><v-icon style="margin: 5px;" size="30" color="red" @click="openPage('appointments')" >mdi-calendar-today</v-icon></div>
      <div v-if="getOdTag && getOdTag.tag_icon ==='flask'" > <v-icon style="margin: 5px;" size="30" color="purple" @click="openPage('lab-cases')">mdi-flask</v-icon></div>
       <div v-if="!labpagestatus && getOdTag && getOdTag.tag_icon === 'clipboard-check-outline'">
              <v-icon
                size="30px"
               :color="getOdTag.tag_icon === 'clipboard-check-outline'? '#9C27B0':'secondary'"
                @click="openPage('PreAuthsDetails')"               
              > mdi-{{getOdTag.tag_icon}}
              </v-icon>
            </div>
            <div v-if="!labpagestatus && getOdTag && getOdTag.tag_icon === 'help-box-multiple-outline'">
              <v-icon
                size="30px"
                :color="getOdTag.tag_icon === 'help-box-multiple-outline'? '#FFC107' :'secondary'"
                @click="openPage('pendingTreatmentDetails')"               
              > mdi-{{getOdTag.tag_icon}}
              </v-icon>
            </div>
    </div>
    </button>
    <v-icon style="margin-top: 10px;" v-if="isPanelVisible" @click="togglePanel" size="26px" color="primary">mdi-arrow-right</v-icon>
    <RightPanel style="overflow-y: hidden;" v-if="isPanelVisible" />
  </div>
</template>

<script>
import RightPanel from '../components/FrontDesk/RightPanel/RightPanel.vue';
import { mapState,mapMutations,mapGetters } from 'vuex';
import EventBus from "@/eventBus";
export default {
  name: 'Frontdesk Right Panel',
  components: {
    RightPanel,
  },
  computed:{
    ...mapGetters('labcases', ['labpagestatus']),
    ...mapGetters("frontdesk",["getOdTag"]),
    ...mapState(['isPanelVisible',"isODEnabled"]),
    ...mapGetters("convos", ["internal_convos"]),
    unreadMessages() {
      return this.internal_convos.filter((convo) => convo.unread);
    },
  },
  methods: {
    ...mapMutations("frontdesk", ["set_right_panel_tab"]),
    ...mapMutations(['changeRightPanelStatus']),
    togglePanel() {
      
      this.changeRightPanelStatus(!this.isPanelVisible);
      if (!this.isPanelVisible) {
        window.scrollTo(0, 0); // Scroll to top when hiding the panel
      }
    },
    closeRightPanel(){
      this.changeRightPanelStatus(false);
      window.scrollTo(0, 0); // Scroll to top when hiding the panel
    },
    openPage(page){
      this.set_right_panel_tab(page);
    }
  },
  mounted(){
    EventBus.$on("close-right-panel",()=>{ this.closeRightPanel()});
  },
  beforeUnmount(){
    EventBus.$off("close-right-panel");
  }
};
</script>

<style>

</style>
